import moment from 'moment';

export default class ExamProxy {
  constructor(props) {
    const { key, value, exam_code, self } = props;
    // 检查项code
    this.exam_code = exam_code;
    // 检查项原始数据
    this.self = self;
    // 设置数据
    this.data = { key, value };
    // 创建代理
    this.createKey().createValue();
  }

  toJSON() {
    return this.data.value;
  }

  /**
   * 创建key代理
   */
  createKey() {
    Object.defineProperty(this, 'key', {
      get() {
        return this.data.key;
      },
      set(value) {
        this.data.key = value;
      },
    });

    return this;
  }

  /**
   * 创建value代理
   */
  createValue() {
    Object.defineProperty(this, 'value', {
      get() {
        return this.data.value;
      },
      set(value) {
        this.data.value = value;
      },
    });

    return this;
  }
}
